import { Dispatch } from 'redux';

import { fetcher, request } from '../../lib/request';

import { HotelOrderLinkParams } from '../../models/Hotels/OrderLink';
import { OrderedMap } from 'immutable';
import { Guest } from '../../models/Hotels/Guest';

const HOTELS_HOST = process.env.REACT_APP_HOTELS_HOST;
const HOTELS_KEY = process.env.REACT_APP_HOTELS_KEY;

export const REQUEST_ORDER_LINK = 'HOTELS_REQUEST_ORDER_LINK';
export const RESPONSE_ORDER_LINK = 'HOTELS_RESPONSE_ORDER_LINK';
export const ERROR_ORDER_LINK = 'HOTELS_ERROR_ORDER_LINK';

export const SET_BOOKING_GUESTS = 'HOTELS_SET_BOOKING_GUESTS';
export const ADD_BOOKING_GUESTS = 'HOTELS_ADD_BOOKING_GUESTS';
export const SET_EMAIL = 'HOTELS_SET_EMAIL';

export const REQUEST_ORDER_PAYLOAD = 'HOTELS_REQUEST_ORDER_PAYLOAD';
export const RESPONSE_ORDER_PAYLOAD = 'HOTELS_RESPONSE_ORDER_PAYLOAD';
export const ERROR_ORDER_PAYLOAD = 'HOTELS_ERROR_ORDER_PAYLOAD';

export const REQUEST_STATUS_NAMES = 'HOTELS_REQUEST_STATUS_NAMES';
export const RESPONSE_STATUS_NAMES = 'HOTELS_RESPONSE_STATUS_NAMES';
export const ERROR_STATUS_NAMES = 'HOTELS_ERROR_STATUS_NAMES';

export const REQUEST_ORDERS = 'HOTELS_REQUEST_ORDERS';
export const RESPONSE_ORDERS = 'HOTELS_RESPONSE_ORDERS';
export const ERROR_ORDERS = 'HOTELS_ERROR_ORDERS';

export const REQUEST_CANCEL_ORDER = 'HOTELS_REQUEST_CANCEL_ORDER';
export const RESPONSE_CANCEL_ORDER = 'HOTELS_RESPONSE_CANCEL_ORDER';
export const ERROR_CANCEL_ORDER = 'HOTELS_ERROR_CANCEL_ORDER';

export const REQUEST_DELETE_ORDER = 'HOTELS_REQUEST_DELETE_ORDER';
export const RESPONSE_DELETE_ORDER = 'HOTELS_RESPONSE_DELETE_ORDER';
export const ERROR_DELETE_ORDER = 'HOTELS_ERROR_DELETE_ORDER';

export const CHANGE_ORDER_STATUS = 'CHANGE_ORDER_STATUS';

export const getOrderLinkAction = (params: HotelOrderLinkParams) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_ORDER_LINK
    });

    try {
        const body = {
            book_hash: params.bookHash,
            client_token: params.userId,
            search_rooms_id: params.searchRoomId,
            return_url: params.returnUrl,
            search_url: params.searchUrl,
            language: params.language
        };

        const response = await fetcher(`${HOTELS_HOST}/v3/order`)
            .post(body)
            .contentType('application/json')
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: RESPONSE_ORDER_LINK,
            response
        });
    } catch (error) {
        dispatch({
            type: ERROR_ORDER_LINK,
            error
        });
    }
};

export const getStatusNamesAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_STATUS_NAMES
    });

    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/order/statuses`)
            .get()
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: RESPONSE_STATUS_NAMES,
            response
        });
    } catch (error) {
        dispatch({
            type: ERROR_STATUS_NAMES,
            error
        });
    }
};

export const getOrdersAction = (userId: string, page: number, status?: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_ORDERS
    });

    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/order?client_token=${userId}&page=${page}${status ? '&status=' + status : ''}`)
            .get()
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: RESPONSE_ORDERS,
            response
        });
    } catch (error) {
        dispatch({
            type: ERROR_ORDERS,
            error
        });
    }
};

export const cancelOrderAction = (digest: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_CANCEL_ORDER
    });

    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/order/${digest}`)
            .delete()
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: RESPONSE_CANCEL_ORDER,
            response
        });
    } catch (error) {
        dispatch({
            type: ERROR_CANCEL_ORDER,
            error
        });
    }
};

export const deleteOrderAction = (digest: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_DELETE_ORDER,
        digest
    });

    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/order/${digest}/deactivate`)
            .delete()
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: RESPONSE_DELETE_ORDER,
            response
        });
    } catch (error) {
        dispatch({
            type: ERROR_DELETE_ORDER,
            error
        });
    }
};

export const getVoucherAction = async (digest: string, lang?: string) => {
    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/order/${digest}/voucher?language=${lang}`)
            .get()
            .auth(`Basic ${HOTELS_KEY}`)
            .fetch();
        return response;
    } catch (error) {
        console.log(error);
        return false;
    }
};

export const setBookingGuestsAction = (guests: OrderedMap<number, Guest>) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_BOOKING_GUESTS,
        guests
    });
};

export const addBookingGuestsAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: ADD_BOOKING_GUESTS
    });
};

export const setEmailAction = (email: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_EMAIL,
        email
    });
};

export const getOrderPayloadAction = (currency: string, price: string, book_hash: string, guests: Guest[], email: string, client_token: string = 'PgwHKV9iflNSboT4PjcL9A') => (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_ORDER_PAYLOAD
    });

    return request(`${process.env.REACT_APP_HOTELS_HOST}/b2b/v1/order_payload`, {
        method: 'POST',
        body: JSON.stringify({
            currency,
            price,
            book_hash,
            guests
        }),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Basic ${process.env.REACT_APP_HOTELS_KEY}`
        })
    }).then((response: any) => {
        const payload = response.result;
        let body: any = {
            client_token: client_token || 'PgwHKV9iflNSboT4PjcL9A',
            service_key: payload.service_key,
            currency_code: payload.currency_code,
            price: payload.price,
            payload: payload.payload
        };
        if (email && email.length) {
            body.email = email;
        }
        request(`${process.env.REACT_APP_CONTENT_HOST}/api/v3/bot_test_payment/booking`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        }).then((res: any) => {
            const booking_id = res.result.id;
            request(`${process.env.REACT_APP_CONTENT_HOST}/api/v3/bot_test_payment/payment/${booking_id}`, {
                method: 'POST'
            }).then((resp: any) => {
                dispatch({
                    type: RESPONSE_ORDER_PAYLOAD,
                    response: resp
                });
            }).catch(error => dispatch({
                type: ERROR_ORDER_PAYLOAD,
                error
            }));
        }).catch(error => dispatch({
            type: ERROR_ORDER_PAYLOAD,
            error
        }));
    }).catch(error => dispatch({
        type: ERROR_ORDER_PAYLOAD,
        error
    }));
};

export const changeOrderStatusAction = (digest: string, status: string) => (dispatch: Dispatch<any>) => dispatch({
    type: CHANGE_ORDER_STATUS,
    digest,
    status,
});



// WEBPACK FOOTER //
// ./src/actions/Hotels/orders.ts